import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const ConfigRequestsInstanceToken = new InjectionToken<ConfigRequestsInterface>('ConfigRequestsInterface');

export interface ConfigRequestsInterface {
    init(): Observable<string[]>;
}
